const csrfToken = () => ({ "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content })

export {
  csrfToken
}
